const EnvironmentColors = {
  development: '#8ADCD5',
  smoketest: '#BF8ADC',
  uat: '#F8C157'
}
export default EnvironmentColors